import { TIME_TRAVEL } from '../mutation-types';
import router from '../../router';

/**
 * Vuex plugin to sync time travel state to URL parameters.
 * Updates the URL's `date` and `tz` params whenever the time state changes.
 */
export default function syncTimeToUrl(store) {
  store.subscribe((mutation, state) => {
    if (mutation.type === TIME_TRAVEL) {
      const { sinceEpoch, zone } = state.time || {};
      if (sinceEpoch && zone) {
        router.replace({
          query: {
            ...router.currentRoute.query,
            date: sinceEpoch,
            tz: zone,
          },
        });
      }
    }
  });
}
